import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import _ from 'lodash';
import { getGenericModal } from "@pwbapps/genericdialog/dist/redux/selectors";
import { Label, TextField } from '@fluentui/react';
import {Actions as ModalActions} from '@pwbapps/genericdialog';
import { NumericFormat } from 'react-number-format';
import { withTranslation, WithTranslation  } from 'react-i18next';

export interface NewSheetProps extends RouteComponentProps, WithTranslation {
    sheetNumber?: number,
    setContextItem: typeof ModalActions.DocumentActions.setContextItem
}
class NewSheet extends React.Component<NewSheetProps> {
    constructor(props: NewSheetProps) {
        super(props);   
    }

    render(){
        const { sheetNumber, setContextItem } = this.props;
        
        return (
            <>                                   
                <Label>Number of sheets</Label>
                <NumericFormat
                    customInput={TextField}
                    decimalScale={0}
                    value={(sheetNumber) ? sheetNumber : ''}
                    autoComplete={'off'}
                    min={1}
                    onValueChange={(values) => {
                        setContextItem({id: 'sheet', item: values.floatValue });
                    }}
                    styles={{root: {minWidth: 256}}}
                />                                                  
            </>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    sheetNumber: (state) => (getGenericModal('sheet')(state)) ? (getGenericModal('sheet')(state) as any).contextItem as number : undefined,
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setContextItem: ModalActions.DocumentActions.setContextItem
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(withTranslation()(withRouter(NewSheet)));